import React from 'react';

function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="footer-inner">
        <div className="footer-newsletter">
          <h3>Sign up for our Newsletter</h3>
          <div className="newsletter-underline"></div>
          <label>Email</label>
          <input type="email" placeholder="your@email.com" className="email-input" />
          <button className="btn-subscribe">Subscribe</button>
        </div>
        <div className="footer-logo-section">
          <div className="ecfa-badge">
            <div className="ecfa-circle">
              <span className="ecfa-text">ECFA</span>
              <span className="ecfa-sub">Enhancing Trust</span>
            </div>
            <p className="ecfa-label">Enhancing Trust</p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>©2023 Christ For India All rights reserved. Design by The Titus Group</p>
      </div>
    </footer>
  );
}

export default Footer;
